import React, { useEffect, useState } from "react";
import {
    Form,
    Input,
    Button,
    InputNumber,
    Row,
    Col,
    Card,
    Switch,
    Select,
} from "antd";

const AddBankData = ({ initialValues, onSubmit, onCancel, handleEQNo }) => {
    const [form] = Form.useForm();
    const { TextArea } = Input;

    const handleFinish = async (values) => {
        try {
            const payload = {
                ...values,
                id: initialValues?.id,
                status: values.status ? "Active" : "Inactive",
            };
            onSubmit(payload);
            form.resetFields();
        } catch (error) {
            console.error("User operation failed:", error);
        }
    };

    useEffect(() => {

        const statusValue = initialValues?.status === "Active" || !initialValues?.status;
        const valuesToSet = {
            ...initialValues,
            status: !!statusValue,
        };

        form.setFieldsValue(valuesToSet);

    }, [initialValues]);

    return (
        <Form
            form={form}
            layout="vertical"
            onFinish={handleFinish}
        >
            <Card style={{ marginBottom: 24 }}>

                <Form.Item
                    name="tag"
                    label="Tag"
                    rules={[{ required: true, message: "Please enter tag" }]}
                >
                    <Input size="large" placeholder="Enter tag" />
                </Form.Item>

                <Form.Item
                    name="bank_name"
                    label="Bank Name"
                    rules={[{ required: true, message: "Please enter bank name" }]}
                >
                    <Input size="large" placeholder="Enter bank name" />
                </Form.Item>

                <Form.Item
                    name="holder_name"
                    label="Bank account holder name"
                    rules={[{ required: true, message: "Please enter bank name" }]}
                >
                    <Input size="large" placeholder="Enter bank name" />
                </Form.Item>


                <Form.Item
                    name="ac_no"
                    label="Bank account number"
                    rules={[
                        { required: true, message: "Please enter bank account number" },
                        {
                            pattern: /^[0-9]+$/,
                            message: "Must be numbers only",
                        },
                    ]}
                >
                    <Input
                        size="large"
                        maxLength={15}
                        placeholder="Enter bank account number"
                    />
                </Form.Item>

                <Form.Item
                    name="ifsc_code"
                    label="IFSC Code"
                    rules={[{ required: true, message: "Please enter IFSC Code" }]}
                >
                    <Input size="large" placeholder="Enter IFSC Code" />
                </Form.Item>

                <Form.Item
                    name="bank_address"
                    label="Bank Address"
                >
                    <TextArea rows={2} size="large" placeholder="Enter Bank Address" />
                </Form.Item>


                <Form.Item
                    name="status"
                    label="Status"
                    valuePropName="checked"
                >
                    <Switch
                        checkedChildren="Active"
                        unCheckedChildren="Inactive"
                        style={{ transform: "scale(1.3)", marginTop: "4px" }}
                    />
                </Form.Item>
            </Card>

            <div style={{ textAlign: "right", marginTop: 24 }}>
                <Button onClick={onCancel} style={{ marginRight: 8 }} size="large">
                    Cancel
                </Button>
                <Button type="primary" htmlType="submit" size="large">
                    {initialValues?.id ? "Update" : "Create"}
                </Button>
            </div>
        </Form>
    );
};

export default AddBankData;